import { render, staticRenderFns } from "./LoadShortCodes.vue?vue&type=template&id=a4052000&"
import script from "./LoadShortCodes.vue?vue&type=script&lang=js&"
export * from "./LoadShortCodes.vue?vue&type=script&lang=js&"
import style0 from "./LoadShortCodes.vue?vue&type=style&index=0&id=a4052000&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports